export default __webpack_public_path__ + "static/media/Carousel3.9a7ee7cd.png";